// source: pbtypes/gen/vehicle_params_for_phone/compatibility_info.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.vehicle_params_for_phone.CompatibilityInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vehicle_params_for_phone.CompatibilityInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vehicle_params_for_phone.CompatibilityInfo.repeatedFields_, null);
};
goog.inherits(proto.vehicle_params_for_phone.CompatibilityInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vehicle_params_for_phone.CompatibilityInfo.displayName = 'proto.vehicle_params_for_phone.CompatibilityInfo';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vehicle_params_for_phone.CompatibilityInfo.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vehicle_params_for_phone.CompatibilityInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.vehicle_params_for_phone.CompatibilityInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_params_for_phone.CompatibilityInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.CompatibilityInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
providedApiChangesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
requiredApiChangesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_params_for_phone.CompatibilityInfo}
 */
proto.vehicle_params_for_phone.CompatibilityInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vehicle_params_for_phone.CompatibilityInfo;
  return proto.vehicle_params_for_phone.CompatibilityInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_params_for_phone.CompatibilityInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_params_for_phone.CompatibilityInfo}
 */
proto.vehicle_params_for_phone.CompatibilityInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      reader.readPackableFixed32Into(msg.getProvidedApiChangesList());
      break;
    case 2:
      reader.readPackableFixed32Into(msg.getRequiredApiChangesList());
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vehicle_params_for_phone.CompatibilityInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vehicle_params_for_phone.CompatibilityInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_params_for_phone.CompatibilityInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.CompatibilityInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProvidedApiChangesList();
  if (f.length > 0) {
    writer.writePackedFixed32(
      1,
      f
    );
  }
  f = message.getRequiredApiChangesList();
  if (f.length > 0) {
    writer.writePackedFixed32(
      2,
      f
    );
  }
};


/**
 * repeated fixed32 provided_api_changes = 1;
 * @return {!Array<number>}
 */
proto.vehicle_params_for_phone.CompatibilityInfo.prototype.getProvidedApiChangesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.vehicle_params_for_phone.CompatibilityInfo} returns this
 */
proto.vehicle_params_for_phone.CompatibilityInfo.prototype.setProvidedApiChangesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.vehicle_params_for_phone.CompatibilityInfo} returns this
 */
proto.vehicle_params_for_phone.CompatibilityInfo.prototype.addProvidedApiChanges = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_params_for_phone.CompatibilityInfo} returns this
 */
proto.vehicle_params_for_phone.CompatibilityInfo.prototype.clearProvidedApiChangesList = function() {
  return this.setProvidedApiChangesList([]);
};


/**
 * repeated fixed32 required_api_changes = 2;
 * @return {!Array<number>}
 */
proto.vehicle_params_for_phone.CompatibilityInfo.prototype.getRequiredApiChangesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.vehicle_params_for_phone.CompatibilityInfo} returns this
 */
proto.vehicle_params_for_phone.CompatibilityInfo.prototype.setRequiredApiChangesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.vehicle_params_for_phone.CompatibilityInfo} returns this
 */
proto.vehicle_params_for_phone.CompatibilityInfo.prototype.addRequiredApiChanges = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_params_for_phone.CompatibilityInfo} returns this
 */
proto.vehicle_params_for_phone.CompatibilityInfo.prototype.clearRequiredApiChangesList = function() {
  return this.setRequiredApiChangesList([]);
};


goog.object.extend(exports, proto.vehicle_params_for_phone);
